import axios from 'axios';
import { installAxiosHeaderValidation } from './axiosHeaderSecurity';

installAxiosHeaderValidation(axios);
